import {Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';

/**
 * Prevents click if selection has been started
 *
 * @example ```html
 * <div (click.prevent-default)="handleClick($event)">Some selectable content</div>
 * ```
 */
@Directive({
  // tslint:disable-next-line: directive-selector
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[click.stop-propagation]'
})
export class ClickStopPropagationDirective implements OnInit, OnDestroy {
  private subscription: () => void;
  @Output('click.stop-propagation') public propagationStopped = new EventEmitter();

  constructor(private renderer: Renderer2, private element: ElementRef) {}

  ngOnInit(): void {
    this.subscription = this.renderer.listen(this.element.nativeElement, 'click', event => {
      event.stopPropagation();
      this.propagationStopped.next(event);
    });
  }

  ngOnDestroy(): void {
    this.subscription();
  }
}
